import React from "react";
import { motion } from "framer-motion";

const WhyMatters = () => {
  return (
    <section
      data-testid="why-section"
      className="relative py-32 md:py-56 bg-[#14100D] text-[#EFE7D6] overflow-hidden"
    >
      {/* Big editorial pull-quote */}
      <div className="max-w-[1400px] mx-auto px-8 md:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="flex items-center gap-6 mb-16"
        >
          <span className="counter">05 — Why Now</span>
          <span className="w-16 hairline-strong h-px inline-block" />
          <span className="overline">Why This Launch Matters</span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.15 }}
          className="relative"
        >
          <div className="absolute -left-4 md:-left-10 -top-8 text-[#E85A15]/20 font-display text-[10rem] md:text-[16rem] leading-none pointer-events-none select-none">
            "
          </div>
          <blockquote
            className="display-tight italic text-[2.5rem] sm:text-6xl md:text-8xl max-w-5xl text-[#EFE7D6] relative z-10"
            data-testid="why-headline"
          >
            The most exciting
            <br />
            <span className="not-italic text-[#DCCFB4]">spirits launch</span>
            <br />
            <span className="italic text-[#E85A15]">in a very long time.</span>
          </blockquote>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="grid md:grid-cols-12 gap-10 mt-24 md:mt-32"
        >
          <div className="md:col-span-4 md:col-start-6">
            <span className="hairline block mb-8" />
            <p className="font-body text-xl md:text-2xl text-[#EFE7D6]/90 leading-[1.5]">
              POG is one of the rarest things in beverage — a regional flavor
              with intense, instant, multi-generational recognition.
            </p>
            <p className="font-body text-base text-[#DCCFB4]/70 leading-[1.75] mt-6 font-light">
              We're not building awareness. We're unlocking it.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyMatters;
